// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"2d472fbe","200":"efe91264"}[chunkId] + ".chunk.js";
};